import TweenMax from 'gsap/TweenMax';

export default function HighHelicopter(
  container,
  canvas,
  duration,
  beforeAnimation
) {
  const {
    left: containerLeft,
    top: containerTop,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const {
    right: canvasRight,
    top: canvasTop,
    height: canvasHeight,
  } = canvas.getBoundingClientRect();
  const initialX = canvasRight - containerLeft - containerWidth / 2;
  const initialY = canvasTop - containerTop + 0.45 * canvasHeight;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
    onComplete: () => {
      TweenMax.to(container, duration - 0.25, {
        y: initialY - 0.45 * canvasHeight,
      });
    },
  });
}
